import React from 'react';
import './dana.css';
import 'antd/dist/antd.css';
import { Switch } from 'antd';

const onChange = (checked) => {
    console.log(`switch to ${checked}`);
}
function Dana() {
    return (
        <div className="card-dana-flow">
            <div className="card-dana1">
                <h5 className="card-dana-title">Pilih Jumlah Dana</h5>
                <div className="flow-donasi-radio">
                    <input className="radio-btn" type="radio" value="Rp.200.000" />
                    <h6 className="radio-btn-value">Rp.200.000</h6>
                </div>
                <div className="flow-donasi-radio">
                    <input className="radio-btn" type="radio" value="Rp.200.000" />
                    <h6 className="radio-btn-value">Rp.100.000</h6>
                </div>
                <div className="flow-donasi-radio">
                    <input className="radio-btn" type="radio" value="Rp.200.000" />
                    <h6 className="radio-btn-value">Rp.50.000</h6>
                </div>
                <div className="flow-donasi-radio">
                    <input className="radio-btn" type="radio" value="Rp.200.000" />
                    <h6 className="radio-btn-value">Rp.25.000</h6>
                </div>
                <div className="flow-donasi-radio">
                    <input className="radio-btn" type="radio" value="Rp.200.000" />
                    <input className="radio-btn-value-1" type="text" placeholder="Masukan Nominal" />
                </div>
            </div>
            <div className="card-dana2">
                <h5 className="card-dana-title">Pilih Metode Pembayaran Donasi</h5>
                <div className="flow-donasi-radio">
                    <input className="radio-btn" type="radio" value="Rp.200.000" />
                    <h6 className="radio-btn-value">Kartu Debit/Kredit</h6>
                </div>
                <div className="flow-donasi-radio">
                    <input className="radio-btn" type="radio" value="Rp.200.000" />
                    <h6 className="radio-btn-value">Saldo E-Wallet</h6>
                </div>
                <div className="flow-donasi-radio">
                    <input className="radio-btn" type="radio" value="Rp.200.000" />
                    <h6 className="radio-btn-value">Transfer ke Rekening Bank</h6>
                </div>
            </div>
            <div className="toggle-row">
                <h6 className="card-dana-title1">Tampilkan Sebagai Anonim</h6>
                <div className="switch-toggle">
                    <Switch defaultChecked onChange={onChange} />
                </div>
            </div>
            <button className="donasi-sekarang-btn-2">Donasi Sekarang</button>
        </div>
    )
}

export default Dana;